import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import suppliers from './suppliers'
import customers from './customers'
import offers from './offers'
import products from './products'
import abilities from '@/store/core/abilities'
import fileUpload from '@/store/core/file_upload'
import cropperUploads from '@/store/core/cropper_uploads'
import cities from '@/store/defines/cities'
import districts from '@/store/defines/districts'
import meets from '@/store/defines/meets'
import brands from '@/store/defines/brands'
import sectors from '@/store/defines/sectors'
import departments from '@/store/defines/departments'
import currencies from '@/store/defines/currencies'
import units from '@/store/defines/units'
import productTypes from '@/store/defines/product_types'
import offerStatus from '@/store/defines/offer_status'
import offerTerms from '@/store/defines/offer_terms'
import banks from '@/store/hrDefines/banks'
import bloodGroup from '@/store/hrDefines/blood_group'
import disabilities from '@/store/hrDefines/disabilities'
import educationLevels from '@/store/hrDefines/education_levels'
import educationalStatuses from '@/store/hrDefines/educational_statuses'
import employeePaymentTypes from '@/store/hrDefines/employee_payment_types'
import employeeTasks from '@/store/hrDefines/employee_tasks'
import genders from '@/store/hrDefines/genders'
import maritals from '@/store/hrDefines/maritals'
import permitTypes from '@/store/hrDefines/permit_types'
import salaryPeriods from '@/store/hrDefines/salary_periods'
import employees from '@/store/hr/employees'
import employeeBank from '@/store/hr/employee_bank'
import employeeContact from '@/store/hr/employee_contact'
import employeePersonal from '@/store/hr/employee_personal'
import employeePosition from '@/store/hr/employee_position'
import employeeSalary from '@/store/hr/employee_salary'
import employeeSalaryDetails from '@/store/hr/employee_salary_details'
import employeePermits from '@/store/hr/employee_permits'
import users from '@/store/config/users'
import userTypes from '@/store/config/user_types'
import smtpConfig from '@/store/config/smtpconfig'
import serviceTypes from '@/store/defines/service_types'
import serviceStatuses from '@/store/defines/service_statuses'
import workers from '@/store/defines/workers'
import services from '@/store/services/services'
import serviceWorks from '@/store/services/service_works'
import serviceWorkers from '@/store/services/service_workers'
import serviceMaterials from '@/store/services/service_materials'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    suppliers,
    customers,
    abilities,
    fileUpload,
    cropperUploads,
    cities,
    districts,
    meets,
    brands,
    sectors,
    departments,
    currencies,
    units,
    productTypes,
    offerStatus,
    offerTerms,
    offers,
    products,
    banks,
    bloodGroup,
    disabilities,
    educationLevels,
    educationalStatuses,
    employeePaymentTypes,
    employeeTasks,
    genders,
    maritals,
    permitTypes,
    salaryPeriods,
    employees,
    employeeBank,
    employeeContact,
    employeePersonal,
    employeePosition,
    employeeSalary,
    employeeSalaryDetails,
    employeePermits,
    users,
    userTypes,
    smtpConfig,
    serviceTypes,
    serviceStatuses,
    workers,
    services,
    serviceWorks,
    serviceWorkers,
    serviceMaterials,
  },
  strict: process.env.DEV,
})
